//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as loglevel from 'loglevel'

interface OtLogger extends loglevel.Logger {
  FOCUS: (message: string, ...args: any[]) => void
  STDOUT: (message: string, ...args: any[]) => void
}

export const logOT: OtLogger = loglevel.getLogger('OpenTradeLogger') as OtLogger
logOT.setLevel(loglevel.levels.INFO)
;(logOT as any).FOCUS = (message: string, ...args: any[]) => {
  logOT.info('FOCUS:' + message, ...args)
}
;(logOT as any).STDOUT = (message: string, ...args: any[]) => {
  logOT.info('STDOUT:' + message, ...args)
}
;(logOT as any).warn = (message: string, ...args: any[]) => {
  logOT.info('FOCUS:' + message, ...args)
}
